<div class="report">
  <report-window (clickOnCloseBtn)="clickOnCloseBtnHandler()">
    <div container-header></div>
    <div container-body>
      <div class="report-header-row">
        <h3 class="report-header-dark">MISSING SUBTITLES REPORT:</h3>
      </div>

      <div class="no-gaps-message" [hidden]="rows.length > 0 || showPreloader">
        <div class="message">
          <b>Great Job!</b>
          <br />
          You Don't have Anymore Missing Subtitles.
        </div>
        <success-v-icon class="success-icon"></success-v-icon>
      </div>
      <div>
        <ngx-datatable
          class="bootstrap"
          [rows]="rows"
          [columns]="columns"
          [columnMode]="'standard'"
          [headerHeight]="50"
          [footerHeight]="20"
          [loadingIndicator]="showPreloader"
          [rowHeight]="'auto'"
          [count]="180"
          [limit]="10"
          [hidden]="rows.length == 0"
        >
          <ngx-datatable-column
            prop="customId"
            name="Id"
          ></ngx-datatable-column>
          <ngx-datatable-column
            prop="mediaTitle"
            name="Title"
          ></ngx-datatable-column>
          <ngx-datatable-column
            prop="missingSubtitles"
            [width]="100"
            name="Missing Subtitles"
            [headerClass]="'row-header'"
            >></ngx-datatable-column
          >
          <ngx-datatable-column
            prop="mediaId"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"
            [checkboxable]="false"
          >
            <ng-template
              ngx-datatable-header-template
              let-value="value"
              let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn"
            >
              <div class="row-header">Edit</div>
            </ng-template>
            <ng-template
              ngx-datatable-cell-template
              let-value="value"
              let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn"
            >
              <div>
                <a
                  [routerLink]="['/mam/editMedia/' + value]"
                  [queryParams]="{ tabIndex: 3 }"
                  class="row-header"
                  >Goto Media</a
                >
                <!--<input type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)"/>-->
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--<ngx-datatable-column name="Name">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                Holla! {{column.name}}
                            </ng-template>
                            <ng-template let-value="value" ngx-datatable-cell-template>
                                Hi: <strong>{{value}}</strong>
                            </ng-template>
                        </ngx-datatable-column>
                            <ngx-datatable-column name="Gender">
                                <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
                                    <span (click)="sort()">{{column.name}}</span>
                                </ng-template>
                                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                    My name is: <i [innerHTML]="row['name']"></i> and <i>{{value}}</i>
                                    <div>{{joke}}</div>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Age">
                                <ng-template let-value="value" ngx-datatable-cell-template>
                                    {{value}}
                                </ng-template>
                            </ngx-datatable-column>-->
        </ngx-datatable>
        <!--<div class='selected-column'>
                            <h4>Selections</h4>
                            <ul>
                                <li *ngFor='let sel of selected'>
                                    {{sel.refToShowBeforeGap}}
                                </li>
                                <li *ngIf="!selected.length">No Selections</li>
                            </ul>
                        </div>-->
      </div>
    </div>
  </report-window>
</div>
